<div>
  <ng-container *ngIf="isCascadeList; else cascadeActions">
    <mat-card>
      <mat-card-header>
        <div class="header flex flex-row justify-between items-center">
          <h3>{{ title }}</h3>
        </div>
      </mat-card-header>
      <mat-card-content>
        <p>{{ lagDevicesList }}</p>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-template #cascadeActions>
    <mat-card>
      <mat-card-header>
        <div class="header flex flex-row justify-between items-center">
          <h3>{{ title }}</h3>
          <mat-slide-toggle
            gtm="onToggle"
            gtmAction="Switch on off strategy"
            gtmCategory="cascadesSequenceStrategy"
            [checked]="isOn"
            [disabled]="!isToggleEnabled"
            (change)="onChanged($event)"
          >
          </mat-slide-toggle>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div class="flex flex-col">
          <ng-content></ng-content>
          <div class="description flex flex-row flex-wrap">{{ description }}</div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>
</div>
